// Crockford-ish alphabet: no 0/O, 1/I/L, U.
const ALPHA = 'ABCDEFGHJKMNPQRSTVWXYZ23456789';

export function newInviteCode(): string {
  const b = new Uint8Array(8);
  crypto.getRandomValues(b);
  return Array.from(b, (x) => ALPHA[x % ALPHA.length]).join('');
}

/** "k7qx-2mpd" → "K7QX2MPD"; returns null when it can't be a code. */
export function normalizeCode(input: string): string | null {
  const s = input
    .trim()
    .replace(/^.*#\/w\//, '')
    .replace(/\/[\s\S]*$/, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  if (s.length !== 8) return null;
  for (const c of s) if (!ALPHA.includes(c)) return null;
  return s;
}

export function formatCode(code: string): string {
  return code.slice(0, 4) + '-' + code.slice(4);
}

export function dmChannel(a: string, b: string): string {
  return 'dm:' + [a, b].sort().join(':');
}

export function agentDmChannel(owner: string, agentId: string): string {
  return 'adm:' + owner + ':' + agentId;
}

/** A member's private chat with someone else's discoverable agent. Its owner is a party too: the agent runs with their key. */
export function guestDmChannel(member: string, owner: string, agentId: string): string {
  return 'gdm:' + member + ':' + owner + ':' + agentId;
}

/** The parts of a gdm: channel id, or null if it isn't one. */
export function parseGuestDm(ch: string): { member: string; owner: string; agentId: string } | null {
  if (!ch.startsWith('gdm:')) return null;
  const [member, owner, ...rest] = ch.slice(4).split(':');
  const agentId = rest.join(':');
  return member && owner && agentId ? { member, owner, agentId } : null;
}

export function isPrivateChannel(ch: string): boolean {
  return ch.startsWith('dm:') || ch.startsWith('adm:') || ch.startsWith('gdm:');
}

export function slug(s: string): string {
  return s
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
}
